import { PathOptions } from "leaflet";

export const cavernas_pe = (feature: any): PathOptions => {
  return {
    color: "#5D4037",
    weight: 2,
    opacity: 1,
    fillColor: "#3E2723",
    fillOpacity: 0.6,
  };
};
